import React from "react";
import {useNavigate} from "react-router-dom";
import "./CustomParlayBanner.style.scss";
import {FormattedMessage} from "react-intl";
import SportIcon from "../../SportIcon/SportIcon";

const SPORT_IDS = [1, 2, 3, 4, 9, 12];

const CustomParlayBanner = (props) => {
    const navigate = useNavigate();
    return (
        <div className="CustomParlayBanner">
            <div>
                <div className="title"><FormattedMessage id="lobbyView.contests.customContest.customParlayBanner.title"/></div>
                <div className="subTitle gold-gradient-text"><FormattedMessage id="lobbyView.contests.customContest.customParlayBanner.subtitle"/></div>
                <div className="sports-icons">
                    {SPORT_IDS.map(id => <SportIcon key={id} sportId={id}/>)}
                </div>
                <div className="btn" onClick={() => navigate('CreateYourOwn')}>
                    <FormattedMessage id="lobbyView.contests.customContest.customParlayBanner.createYourContest"/>
                </div>
            </div>
        </div>
    );
}

export default CustomParlayBanner;
